<template>
    <el-dialog
            title="上传"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            width="532px"
            :before-close="handleClose">
        <div>
            <ElementForm
                ref="form"
                :form.sync="newForm"
                @onAttr="onAttr"
            />
            <el-form v-if="type!='animation'" size="medium" label-width="80px">
                <el-form-item :label="'* '+upData[this.newType].name" prop="cover">
                    <el-upload
                    action="#"
                    :http-request="upFile"
                    :accept="upaccept"
                    list-type="picture-card"
                    :show-file-list="false"
                    :on-change="checkFile"
                    :multiple="false">
                        <img v-if="imageUrl && type=='image'" :src="imageUrl" class="avatar">
                        <span v-if="imageUrl && type!='image'" class="extend">.mp3</span>
                        <i v-if="!imageUrl" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button :loading="isEditing" type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import COS from 'cos-js-sdk-v5'
    import * as commonServer from "../../../../../../../../../../api/common";
    import {typeEnums} from "./fields";

    export default {
        name: "upload-form",
        props: {
            type: String,
            form: Array,
            visible: {
                type: Boolean,
                default: true
            },
            isPlat: {
                type: Boolean,
                default: false
            },
            defaultValue: {
                type: Object
            }
        },
        watch:{
            type(vl){this.newType = vl},
            newType(vl){this.$emit('update:type', vl)},
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){this.$emit('update:visible', vl)},
            form(vl){this.newForm = vl;},
            newForm(vl){this.$emit('update:form', vl)},
            isPlat(vl){this.newIsPlat = vl},
            newIsPlat(vl){this.$emit('update:isPlat', vl)}
        },
        computed: {
            getResourceCategoryTree(){
                return this.isPlat?'getResourceCategoryShopTree':'getResourceCategoryTree'
            },
            addResource(){
                return this.isPlat?'addResourceShop':'addResource'
            },
            getResourceList(){
                return this.isPlat?'getResourceListShop':'getResourceList'
            }
        },
        data(){
            return {
                newType: this.type,
                dialogVisible: this.visible,
                newForm: JSON.parse(JSON.stringify(typeEnums[this.type])),
                oldForm: null,
                isEditing: false, // 是否正在编辑
                uploadFiles: [], // 待上传文件列表
                imageUrl:'',
                upData:{
                    "image":{name:"上传图片",type:['.jpg', '.jpeg', '.png', '.gif'],maxSize:2},
                    "video":{name:"上传视频",type:['.mp4'],maxSize:30},
                    "audio":{name:"上传音频",type:['.mp3'],maxSize:5},
                    "animation":{name:"上传动画",type:['.zip'],maxSize:50},
                },
                fileInfo:{},
                upaccept:'',
            }
        },
        created() {
            this.init()
            let _type=this.upData[this.type].type;
            this.upaccept=_type.toString();
        },
        methods: {
            async init(){
                // 设置表单初始化
                this.defaultValue && Object.keys(this.defaultValue).length > 0 && this.newForm.map(v=>{
                    if(this.defaultValue[v.attr]){
                        v.value = this.defaultValue[v.attr]
                    }
                })

                // 获取目录列表
                const res = await commonServer.default[this.getResourceCategoryTree]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type
                })
                let data = res.data
                console.log('upload->form==>', res)
                let index = this.$utils.getIndexByAttr({attr:'categoryId', data: this.newForm})
                this.newForm[index].options = this.$utils.FormatData(data)

                // 判断是否是公共资源
                this.newForm.map(v=>{
                    v.isPlat = this.isPlat
                })
                
                if(this.type === 'scenes') {
                    this.getNavList()
                }
            },
            // 获取导航列表
            async getNavList () {
                const obj = { clientsId: this.$store.state.initConfig.school_id, page_per: 1000, sort: 'scenes_stage' }
                const res = await commonServer.default[this.getResourceList](obj)
                console.log('res==>导航', res)
                // debugger
                let index = this.$utils.getIndexByAttr({attr:'scenes_stage_id', data: this.newForm})
                this.newForm[index].options = this.$utils.FormatData(res.items)
            },
            onAttr (item, index, target) {
                if (this.isEditing) {
                    return false
                }

                console.log('onAttr=>', item, index, target)
                switch (item.attr) {
                    case 'scenes_stage_id':
                        this.getImageLength()
                        break
                    case 'url': {
                        let obj = index
                        if (typeof obj === 'object') {
                            let nameIndex = this.$utils.getIndexByAttr({attr: 'name', data: this.newForm})
                            this.newForm[nameIndex].value = obj.name
                        }
                        break
                    }
                    case 'remotepath': {
                        this.changeRemotepath(item)
                        break
                    }
                    default:
                }
            },
            changeRemotepath (data) {
                console.log('changeRemotepath==>', data)
                // 1.获取当前素材文件的内容
                // 2.如果素材存在内容，自动设置动画名称
                const indexRemotepath = this.$utils.getIndexByAttr({ attr: data.attr, data: this.newForm })
                const indexName = this.$utils.getIndexByAttr({ attr: 'name', data: this.newForm })
                const obj = this.newForm[indexRemotepath].value
                if (obj.name) {
                    this.newForm[indexName].value = obj.name.replace('.zip', '')
                }
            },
            getImageLength () {
                let oldArr = []
                try {
                    let index = this.$utils.getIndexByAttr({attr:'scenes_stage_id', data: this.newForm})
                    let value = this.$utils.getObjByAttr({attr:'scenes_stage_id', data: this.newForm}).value
                    this.newForm[index].options.map(v => {
                        if (`${v.key}` === `${value}`) {
                            oldArr = v.attributes.options || []
                        }
                    })
                } catch (e) {
                    console.log('等待获取图片长度==>')
                }
                let index = this.$utils.getIndexByAttr({attr: 'options', data: this.newForm})
                this.newForm[index].value = (oldArr || []).map(v => ({ url: '', name: v }))
            },
            getNewChilrens (data) {
                let obj = {}
                return data.map(v => {
                    obj = {
                        key: `${v.id}`,
                        value: v.name
                    }
                    if (v.childrens && v.childrens.length > 0) {
                        obj.children = this.getNewChilrens(v.childrens)
                    }
                    return obj
                })
            },
            handleClose() {
                this.dialogVisible = false
            },
            async submit() {
                this.isEditing = true

                this.oldForm = this.$_.cloneDeepWith(this.newForm)
                let state = this.$refs.form.validateForm()
                if(state){
                    // 提交目录
                    //let urlIndex = this.$utils.getIndexByAttr({attr: 'url', data: this.newForm})
                    let categoryIdIndex = this.$utils.getIndexByAttr({attr: 'categoryId', data: this.newForm})
                    let nameIndex = this.$utils.getIndexByAttr({attr: 'name', data: this.newForm})
                    let aliasIndex = this.$utils.getIndexByAttr({attr: 'alias', data: this.newForm})
                    let scenesStageIdIndex = this.$utils.getIndexByAttr({attr: 'scenes_stage_id', data: this.newForm})
                    let url = ''
                    try{
                        let oldUrl = this.fileInfo.src;//this.newForm[urlIndex].value
                        if(['image', 'audio', 'video'].includes(this.type)) oldUrl = this.fileInfo.src;//this.newForm[urlIndex].value.url
                        //if(urlIndex> -1)url = oldUrl.split('.com/')[oldUrl.split('.com/').length-1]
                        url = oldUrl.split('.com/')[oldUrl.split('.com/').length-1]
                    }catch(e){
                        console.log('替换失败==>', e)
                    }
                    // console.log(categoryIdIndex, nameIndex,aliasIndex)
                    // debugger

                    let obj = {
                        is_online: true,
                        clientsId: this.$store.state.initConfig.school_id,
                        sort: this.type,
                        categoryId: this.newForm[categoryIdIndex]?this.newForm[categoryIdIndex].value[this.newForm[categoryIdIndex].value.length-1]:0,
                        name: this.newForm[nameIndex].value || url,
                        cover: 'default.jpg',
                        attributes: {
                            type: 'flash',
                            cover: 'default.jpg',
                            remotepath: url,
                            md5: url.indexOf('.') > -1?url.split('.')[0] : url
                        }
                    }
                    console.log("this.fileInfo",this.fileInfo);
                    switch (this.type) {
                        // 图片
                        case 'image':
                        case 'audio':
                        case 'video':
                            // obj.name = this.$utils.getObjByAttr({attr: 'url', data: this.newForm}).value.name
                            obj.alias = this.newForm[aliasIndex].value
                            obj.attributes = {
                                //cover: this.$utils.getObjByAttr({attr: 'url', data: this.newForm}).value.url,
                                cover:this.fileInfo.url,
                                remotepath: url,
                                md5: url.indexOf('.') > -1?url.split('.')[0] : url
                            }
                            break
                        // 场景
                        case 'scenes':
                            obj.name = this.$utils.getObjByAttr({attr: 'name', data: this.newForm}).value
                            obj.attributes = {
                                scenes_stage_id: parseInt(this.newForm[scenesStageIdIndex].value),
                                cover: this.$utils.getObjByAttr({attr:'cover',data: this.newForm}).value,
                                // remark: this.$utils.getObjByAttr({attr:'remark',data: this.newForm}).value,
                                options: this.$utils.getObjByAttr({attr:'options',data: this.newForm}).value.map(v => {
                                    return {
                                        [(v.name && v.name.name) || v.name]: v.url
                                    }
                                })
                            }
                            break
                        // 动画
                        case 'animation': {
                            const newMd5 = this.$utils.getObjByAttr({attr: 'remotepath', data: this.newForm})
                            obj.alias = this.newForm[aliasIndex].value
                            obj.name = this.$utils.getObjByAttr({attr: 'name', data: this.newForm}).value
                            const remotepath = newMd5.value.url.split('.com/')[1]
                            obj.attributes = {
                                type: this.$utils.getObjByAttr({attr: 'type', data: this.newForm}).value,
                                cover: this.$utils.getObjByAttr({attr: 'cover', data: this.newForm}).value,
                                remotepath,
                                md5: this.$utils.getMd5(newMd5.value.url),
                                md5_view: this.$utils.getHtmlMd5(this.$utils.getObjByAttr({
                                    attr: 'remotepath_view',
                                    data: this.newForm
                                }).value),
                                remotepath_view: this.$utils.getHtml(this.$utils.getObjByAttr({
                                    attr: 'remotepath_view',
                                    data: this.newForm
                                }).value),
                                background_img: this.$utils.getObjByAttr({
                                    attr: 'background_img',
                                    data: this.newForm
                                }).value,
                                background_audio: this.$utils.getObjByAttr({
                                    attr: 'background_audio',
                                    data: this.newForm
                                }).value
                            }
                            break
                        }
                        default:
                    }

                    const res = await commonServer.default[this.addResource](obj)
                    if (`${res.status_code}` === '200') {
                        console.log('上传成功==>', res)
                        this.$emit('success', res.data.id)
                        this.handleClose()
                    } else if (`${res.status_code}` === '422') {
                        // let err = ''
                        // if(res.errors && res.errors.name){
                        //     err = res.errors.name.toString()
                        // }else if(res.message){
                        //     err = res.message
                        // }
                        // this.$message.error(err)
                        this.newForm = this.oldForm
                    } else {
                        // this.$message.error(res)
                        console.log('错误自行处理==>', res)
                        this.newForm = this.oldForm
                    }
                }

                this.isEditing = false
            },
            // 获取上传标题
            getResourceName(){
                let name = ''
                switch (this.type) {
                    case 'image':
                    case 'scenes':
                        name = '图片'
                        break;
                    case 'audio':
                        name = '音频'
                        break;
                    case 'video':
                        name = '视频'
                        break;
                    case 'animation':
                        name = '动画'
                        break;
                }
                return name
            },
            checkFile(file) {
                if(this.type!="image")return this.pushFile(file, '');
                if (!this.upData[this.newType].type.includes(file.name.match(/\.\w+$/)[0].toLowerCase())) {
                    let _type=this.upData[this.newType].type;
                    this.$message.warning('请上传 '+_type+' 类型文件')
                    return false;
                }
                return new Promise(() => {
                    let reader = new FileReader();
                    reader.readAsDataURL(file.raw); // 必须用file.raw
                    reader.onload = () => {
                        // 让页面中的img标签的src指向读取的路径
                        let img = new Image();
                        img.src = reader.result;
                        if (img.complete) { // 如果存在浏览器缓存中
                            console.log("img1",img.width+"|"+img.height+"|"+file.size)
                            this.pushFile (file, img)
                        } else {
                            img.onload = () => {
                                this.pushFile (file, img)
                            }
                        }
                    };
                })
            },// 上传 图片和文档
            // 上传图片 - 格式限制 所有文件(*.*)
            pushFile (file, img) {
                console.log("file",file);
                if (!this.upData[this.newType].type.includes(file.name.match(/\.\w+$/)[0].toLowerCase())) {
                    let _type=this.upData[this.newType].type;
                    this.$message.warning('请上传 '+_type+' 类型文件')
                    return false;
                }
            
                if(file.size>1024*1024*this.upData[this.newType].maxSize){
                    this.$message.warning('文件不能大于 '+this.upData[this.newType].maxSize+'M ，请压缩后上传。')
                    return false;
                }
                
                if(this.type=="image" && (img.width>1920 || img.height>1080)){
                    this.$message.warning('图片不能大于 1920px*1080px，请压缩后上传。')
                    return false;
                }
                
                this.uploadFiles=[];
                this.uploadFiles.push(file)
                this.upFile ();
            },
            upFile () {
                const files = this.uploadFiles
                files.map((val, index) => {
                    if (!val.loading) {
                        val.loading = true
                        const _t = this.$store.state.tencent
                        const _r = _t.resource_token
                        const md5 = this.$md5(JSON.stringify(val.raw))
                        let newFileName = md5 + '.' + val.name.split('.')[1]
                        // 分组存储
                        if (_t.resource_meta.resource_dir) {
                            newFileName = _t.resource_meta.resource_dir + newFileName
                        }
                        this.$set(files[index], 'progress', '0%')
                    new COS({
                        SecretId: _r.credentials.tmpSecretId,
                        SecretKey: _r.credentials.tmpSecretKey,
                        XCosSecurityToken: _r.credentials.sessionToken,
                        ExpiredTime: _r.expiredTime
                    }).putObject(
                        {
                        'x-cos-meta-fileName': encodeURIComponent(val.name),
                        Bucket: _t.resource_meta.bucket,
                        Region: _t.resource_meta.region,
                        Key: newFileName,
                        Body: val.raw,
                        EnableMD5: true, // 开启md5自定义
                        'x-cos-meta-md5': md5,
                        onProgress: function (res) {
                            for (let i = 0; i < files.length; i++) {
                                if (files[i].uid === val.uid) {
                                    this.$set(
                                    files[i],
                                    'progress',
                                    (res.percent.toFixed(2) * 1e3) / 10 + '%'
                                    )
                                    break
                                }
                            }
                        }
                        },
                        (err, data) => {
                            if (err && err.statusCode === 403) {
                                this.$message.error('token失效, 请刷新页面！')
                            } else {
                                for (let i = 0; i < files.length; i++) {
                                    if (files[i].uid === val.uid) {
                                        this.$set(files[i], 'src', `https://${data.Location}`)
                                        break
                                    }
                                }
                                this.fileInfo=val;
                                let _ext=val.name.match(/\.\w+$/);
                                this.imageUrl=val.src;
                                this.newForm[1].value=val.name.replace(_ext,"");
                                // 上传成功
                                //this.fileList.push(val)
                                //this.$emit('changeData', this.fileList)
                            }
                        }
                    )
                    }
                })
            },
        }
    }
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 146px;
    height: 146px;
    display: block;
	object-fit: contain;
	object-position: center center;
    border-radius: 6px;
}
</style>
